
$(document).ready(function () {

  $('.banner-slides-container').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    speed: 300,
    infinite: true,
    adaptiveHeight: true
  });

  
  $(".customer-reviews-cards-track").slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 989,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

});


$(document).ready(function () {
  function initShopByCollectionSlider() {
    if (window.innerWidth <= 639) {
      if (!$('.shop-by-collection-grid').hasClass('slick-initialized')) {
        $('.shop-by-collection-grid').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 2,
          slidesPerRow: 1,
          arrows: true,
          dots: false,
          speed: 300,
          infinite: true,
          adaptiveHeight: false
        });
      }
    } else {
      if ($('.shop-by-collection-grid').hasClass('slick-initialized')) {
        $('.shop-by-collection-grid').slick('unslick');
      }
    }
  }

  initShopByCollectionSlider();

  $(window).on('resize', function () {
    initShopByCollectionSlider();
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const customMenu = document.querySelector('.mobile_custom_menu');
  const menuDrawer = document.querySelector('#Details-menu-drawer-container');

  if (!customMenu || !menuDrawer) return;

  const menuTrigger = menuDrawer.querySelector('summary');

  // Custom bottom menu click
  customMenu.addEventListener('click', function (e) {
    e.preventDefault();

    if (menuDrawer.hasAttribute('open')) {
      // Close menu
      menuTrigger.click();
      customMenu.classList.remove('active');
    } else {
      // Open menu
      menuTrigger.click();
      customMenu.classList.add('active');
    }
  });

  // Detect when Shopify closes/opens the drawer
  menuDrawer.addEventListener('toggle', function () {
    if (menuDrawer.hasAttribute('open')) {
      customMenu.classList.add('active');
    } else {
      customMenu.classList.remove('active');
    }
  });
});


